<ngx-spinner [name]="'consultar-funcionario'" type="ball-clip-rotate-pulse" [fullScreen]="false"
    bdColor="rgba(0, 0, 0, 0.2)"></ngx-spinner>
<mat-card>
    <mat-card-header>
        <mat-card-title>Consultar Funcionario</mat-card-title>
    </mat-card-header>
    <mat-divider></mat-divider>

    <mat-card-content *ngIf="!bConsulta">
        <div class="row">
            <div class="col-sm-6">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                    <mat-label>Filtro</mat-label>
                    <input matInput (keyup)="aplicarFiltroTabela($event)" placeholder="Filtro">
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col-sm">
                <table mat-table [dataSource]="funcionarioSource" class="mat-elevation-z2" style="width: 100%;">

                    <ng-container matColumnDef="Nome">
                        <th mat-header-cell *matHeaderCellDef> Nome </th>
                        <td mat-cell *matCellDef="let element"> {{element.Nome}} </td>
                    </ng-container>

                    <ng-container matColumnDef="CPF">
                        <th mat-header-cell *matHeaderCellDef> CPF </th>
                        <td mat-cell *matCellDef="let element"> {{element.CPF}} </td>
                    </ng-container>

                    <ng-container matColumnDef="Email">
                        <th mat-header-cell *matHeaderCellDef> Email </th>
                        <td mat-cell *matCellDef="let element"> {{element.Email}} </td>
                    </ng-container>

                    <ng-container matColumnDef="Telefone">
                        <th mat-header-cell *matHeaderCellDef> Telefone </th>
                        <td mat-cell *matCellDef="let element"> {{element.Telefone}} </td>
                    </ng-container>

                    <ng-container matColumnDef="Gerente">
                        <th mat-header-cell *matHeaderCellDef> Gerente </th>
                        <td mat-cell *matCellDef="let element"> {{element.Gerente}} </td>
                    </ng-container>

                    <ng-container matColumnDef="StatusString">
                        <th mat-header-cell *matHeaderCellDef> Status </th>
                        <td mat-cell *matCellDef="let element"> {{element.StatusString}} </td>
                    </ng-container>

                    <ng-container matColumnDef="Consultar">
                        <th mat-header-cell *matHeaderCellDef> Consultar </th>
                        <td mat-cell *matCellDef="let element">
                            <button mat-icon-button matTooltip="Detalhar funcionário" (click)="consultarFuncionario(element)"
                                class="iconbutton" color="primary">
                                <mat-icon aria-label="Expandir">search</mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="consultarFuncionario(row)">
                    </tr>

                    <!-- Row shown when there is no matching data that will be provided to the wrapper table. -->
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="6" style="text-align: center;">Não há funcionários cadastrados no
                            sistema ou com o filtro definido
                        </td>
                    </tr>
                </table>

                <mat-paginator [pageSizeOptions]="[10, 15, 20, 25]"></mat-paginator>
            </div>
        </div>
    </mat-card-content>


    <mat-card-content *ngIf="bConsulta">

        <form [formGroup]="funcionarioForm">
            <div class="row">
                <div class="col-auto">
                    <div class="custom-checkbox custom-control">
                        <input type="checkbox" formControlName="status" id="remember" class="custom-control-input">
                        <label for="remember" class="custom-control-label">
                            <div style="margin-top: 3px;">Status</div>
                        </label>
                    </div>
                </div>

                <div class="col-sm text-right mr-2">
                    Cadastrado dia: <strong>{{f.dataCadastro.value}}</strong>
                </div>
            </div>


            <div class="row mt-4">
                <div class="col-auto">
                    <h1 class="customH1">Informações Gerais</h1>
                </div>
                <div class="col-sm">
                    <hr />
                </div>
            </div>

            <div class="borda">

                <div class="row">
                    <div class="col-sm-4">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>Nome</mat-label>
                            <input type="text" matInput formControlName="nome" required maxlength="100">
                            <mat-error *ngIf="f.nome.errors">
                                Campo obrigatório
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-2">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>CPF</mat-label>
                            <input type="text" matInput formControlName="cpf" required maxlength="100">
                            <mat-error *ngIf="f.cpf.errors?.required">
                                Campo obrigatório
                            </mat-error>
                            <mat-error *ngIf="f.cpf.errors?.cpfValido">
                                CPF inválido
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col-auto">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>Telefone</mat-label>
                            <input type="text" matInput formControlName="telefone" [textMask]="{mask: maskTelefone}"
                                (ngModelChange)="onChangeTel($event, true)" required>
                                <mat-error *ngIf="f.telefone.errors?.required">
                                    Campo obrigatório
                                </mat-error>
                                <mat-error *ngIf="f.telefone.errors?.telefoneValido">
                                    Telefone inválido
                                </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-auto">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>Telefone Secundário</mat-label>
                            <input type="text" matInput formControlName="telefoneSecundario"
                                [textMask]="{mask: maskTelefone2}" (ngModelChange)="onChangeTel($event, false)">
                        </mat-form-field>
                    </div>

                    <div class="col-2" *ngIf="f.bVender.value">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>Comissão</mat-label>
                            <input type="number" matInput formControlName="comissao">
                            <span matSuffix>
                                %
                            </span>
                        </mat-form-field>
                    </div>
                </div>

            </div>

            <div class="row mt-4">
                <div class="col-auto">
                    <h1 class="customH1">Permissões</h1>
                </div>
                <div class="col-sm">
                    <hr />
                </div>
            </div>

            <div class="borda">
                <div class="row">
                    <div class="col-auto">
                        <ul>
                            <li class="tituloLi">
                                <mat-checkbox formControlName="bTodosCadastro" [labelPosition]="'before'"
                                    (click)="allCheck('Cadastrar')" [color]="'warn'">
                                    Cadastrar</mat-checkbox>
                            </li>
                            <div class="bordaLista">
                                <li>
                                    <mat-checkbox formControlName="bRealizarCadastroClientes" [color]="'primary'">
                                        Clientes</mat-checkbox>
                                </li>
                                <li>
                                    <mat-checkbox class="example-margin" formControlName="bRealizarCadastroFornecedores"
                                        [color]="'primary'">
                                        Fornecedores</mat-checkbox>
                                </li>
                                <li>
                                    <mat-checkbox class="example-margin" formControlName="bRealizarCadastroFuncionarios"
                                        [color]="'primary'">
                                        Funcionários</mat-checkbox>
                                </li>
                                <li>
                                    <mat-checkbox formControlName="bRealizarCadastroGrupos" [color]="'primary'">
                                        Grupos</mat-checkbox>
                                </li>
                                <li>
                                    <mat-checkbox formControlName="bRealizarCadastroProdutos" [color]="'primary'">
                                        Produtos</mat-checkbox>
                                </li>
                            </div>
                        </ul>
                    </div>

                    <div class="col-auto">
                        <ul>
                            <li class="tituloLi">
                                <mat-checkbox formControlName="bTodosConsulta" [labelPosition]="'before'"
                                    (click)="allCheck('Consultar')" [color]="'warn'" (change)="checkAlterado()">
                                    Consultar</mat-checkbox>
                            </li>
                            <div class="bordaLista">
                                <li>
                                    <mat-checkbox formControlName="bRealizarConsultaClientes" [color]="'primary'"
                                        (change)="checkAlterado()">
                                        Clientes</mat-checkbox>
                                </li>
                                <li>
                                    <mat-checkbox class="example-margin" formControlName="bRealizarConsultaFornecedores"
                                        [color]="'primary'" (change)="checkAlterado()">
                                        Fornecedores</mat-checkbox>
                                </li>
                                <li>
                                    <mat-checkbox class="example-margin" formControlName="bRealizarConsultaFuncionarios"
                                        [color]="'primary'" (change)="checkAlterado()">
                                        Funcionários</mat-checkbox>
                                </li>
                                <li>
                                    <mat-checkbox formControlName="bRealizarConsultaGrupos" [color]="'primary'"
                                        (change)="checkAlterado()">
                                        Grupos</mat-checkbox>
                                </li>
                                <li>
                                    <mat-checkbox formControlName="bRealizarConsultaProdutos" [color]="'primary'"
                                        (change)="checkAlterado()">
                                        Produtos</mat-checkbox>
                                </li>
                                <li>
                                    <mat-checkbox formControlName="bRealizarConsultaLogs" [color]="'primary'"
                                        (change)="checkAlterado()">
                                        Log's</mat-checkbox>
                                </li>
                            </div>
                        </ul>
                    </div>

                    <div class="col-auto">
                        <ul>
                            <li class="tituloLi">
                                <mat-checkbox formControlName="bTodosAlterar" [labelPosition]="'before'"
                                    (click)="allCheck('Alterar')" [color]="'warn'">
                                    Alterar</mat-checkbox>
                            </li>
                            <div class="bordaLista">
                                <li>
                                    <mat-checkbox formControlName="bAlterarClientes" [color]="'primary'">
                                        Clientes</mat-checkbox>
                                </li>
                                <li>
                                    <mat-checkbox class="example-margin" formControlName="bAlterarFornecedores"
                                        [color]="'primary'">
                                        Fornecedores</mat-checkbox>
                                </li>
                                <li>
                                    <mat-checkbox class="example-margin" formControlName="bAlterarFuncionarios"
                                        [color]="'primary'">
                                        Funcionários</mat-checkbox>
                                </li>
                                <li>
                                    <mat-checkbox formControlName="bAlterarGrupos" [color]="'primary'">
                                        Grupos</mat-checkbox>
                                </li>
                                <li>
                                    <mat-checkbox formControlName="bAlterarProdutos" [color]="'primary'"
                                        (change)="checkAlterado()">
                                        Produtos</mat-checkbox>
                                </li>
                            </div>
                        </ul>
                    </div>

                    <div class="col-auto">
                        <ul>
                            <li class="tituloLi">
                                <mat-checkbox formControlName="bTodosExcluir" [labelPosition]="'before'"
                                    (click)="allCheck('Excluir')" [color]="'warn'">
                                    Excluir</mat-checkbox>
                            </li>
                            <div class="bordaLista">
                                <li>
                                    <mat-checkbox formControlName="bExcluirVendas" [color]="'primary'">
                                        Venda</mat-checkbox>
                                </li>
                                <li>
                                    <mat-checkbox class="example-margin" formControlName="bExcluirProdutos"
                                        [color]="'primary'">
                                        Produtos</mat-checkbox>
                                </li>
                            </div>
                        </ul>
                    </div>

                    <div class="col-auto">
                        <ul>
                            <li class="tituloLi">
                                <mat-checkbox formControlName="bTodosDemaisFuncoes" [labelPosition]="'before'"
                                    (click)="allCheck('DemaisFuncoes')" [color]="'warn'"
                                    (keyup.space)="allCheck('DemaisFuncoes')">
                                    Demais funcões</mat-checkbox>
                            </li>
                            <div class="bordaLista">
                                <li>
                                    <mat-checkbox formControlName="bVender" [color]="'primary'">
                                        Vender</mat-checkbox>
                                </li>
                                <li>
                                    <mat-checkbox class="example-margin" formControlName="bGerente" [color]="'primary'">
                                        Gerente</mat-checkbox>
                                </li>
                            </div>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="row mt-4">
                <div class="col-auto">
                    <h1 class="customH1">Informações de Acesso</h1>
                </div>
                <div class="col-sm">
                    <hr />
                </div>
            </div>

            <div class="borda">
                <div class="row">
                    <div class="col-4">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>Email</mat-label>
                            <input type="text" matInput formControlName="email">
                            <mat-error *ngIf="f.email.errors">
                                Campo obrigatório
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-auto">
                        <button mat-stroked-button color="link" (click)="recuperarSenha()" style="margin-top: 20px;">
                            <mat-icon>email</mat-icon> Esqueceu a senha
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </mat-card-content>

    <mat-divider *ngIf="bConsulta"></mat-divider>

    <section fxLayout fxLayoutAlign="space-between center" class="mtSection" *ngIf="bConsulta">
        <button mat-flat-button color="warn" (click)="voltar()">
            <mat-icon>arrow_back</mat-icon> Voltar
        </button>
        <button mat-flat-button color="primary" (click)="salvar()">
            <mat-icon>check</mat-icon> Salvar
        </button>
    </section>


</mat-card>
